if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        // super.hide();
      }

      show(opener) {
        super.show(opener);
        model_slider();
      //  this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube"))
          activeMedia.loadContent();
      }
    }
  );
}
  document.querySelectorAll(".product-media-modal__toggle1").forEach(function (toggleButton) {
      toggleButton.addEventListener("click", function () {
        var productModal = toggleButton.closest("product-modal");
        if (productModal) {
          productModal.removeAttribute("open");
          document.querySelector("body").classList.remove("overflow-hidden");
            if( $(".js-youtube").length >0){
              $('.js-youtube').each(function(index) {
              $(this).attr('src', $(this).attr('src'));
              return false;
              });
             //  $('.js-youtube').each(function() {
             //  var iframe = $(this)[0];  // Get the iframe element
             //  var iframeWindow = iframe.contentWindow;  // Get the iframe's contentWindow
             // // Send the pause command via postMessage
             //  iframeWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
             //  })
           
          }
        }
       
      });
    });
  $(document).on('click','.modal-product-thumbnail .thumb-image',function(){
     var index= $(this).attr('data-slick-index');
 $(".product-media-modal__content_slider").slick("slickGoTo",index);
   });
      function model_slider(){
        $(".product-media-modal__content_slider:not(.product-media-modal__content_slider.slick-slider)").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          useTransform: true, // Mandatory to use cssEase 
          // cssEase: 'ease-in',
          //asNavFor: ".modal-product-thumbnail",
        });
        // $( ".modal-product-thumbnail:not(.modal-product-thumbnail.slick-slider)").slick({
        //   arrows: false,
        //   draggable: false,
        //   variableWidth: false,
        //   slidesToShow:10,
        //   slidesToScroll:1,
        //    asNavFor: ".product-media-modal__content_slider",
        //   responsive: [
        //     {
        //       breakpoint: 767,
        //       settings: {
        //         slidesToShow: 5,
        //       },
        //     },
        //   ],
        // });
  
        
        /** Change slide on mouse scroll **/
        var slider = $(".product-media-modal__content_slider");
        var scrollCount = null;
        var scroll = null;
        slider.on("wheel", function (e) {
          e.preventDefault();

          clearTimeout(scroll);
          scroll = setTimeout(function () {
            scrollCount = 0;
          }, 200);
          if (scrollCount) return 0;
          scrollCount = 1;

          if (e.originalEvent.deltaY < 0) {
            $(this).slick("slickNext");
          } else {
            $(this).slick("slickPrev");
          }
        });
        /** Change slide on mouse scroll END HERE**/
      }
     
      $(".modal-product-thumbnail .slick-slide").click(function () {
          var index = $(this).index(); // Get the index of the clicked thumbnail
          $(".product-media-modal__content_slider").slick("slickGoTo", index); // Move to the corresponding slide
        });
        // On click on view more link
        $(".thumb-viewmore,.thumbnail-list__item").on("click", function (e) {
          e.preventDefault();
          model_slider();
           var slideIndex = parseInt($(this).attr('data-media-position')) - 1;
          $('product-modal').attr('open',true);
          $('body').addClass('overflow-hidden');
         $(".product-media-modal__content_slider").slick("slickGoTo",slideIndex);

         
           $('.model-top-content #lg-counter-current').html(slideIndex+1);
            if($(`.product-media-modal__content_slider .slick-slide[data-slick-index=${slideIndex}] img`).attr('alt') !='blank'){
            $('.model-product-title').html($(`.product-media-modal__content_slider .slick-slide[data-slick-index=${slideIndex}] img`).attr('alt'));
            }else{
            $('.model-product-title').html($(`${pmodal}`).attr('data-title'));
            }
          const resizeEvent = new Event('resize');
          // Dispatch the event
        window.dispatchEvent(resizeEvent);
  //           if($( ".modal-product-thumbnail").length <7){
  //             setTimeout(function() {
   
  //    $('.modal-product-thumbnail').slick('unslick'); // Unslick (destroy) the thumbnail slider
  //    $( ".modal-product-thumbnail:not(.modal-product-thumbnail.slick-slider)").slick({
  //         arrows: false,
  //         draggable: false,
  //         variableWidth: true,
  //         slidesToShow:10,
  //         slidesToScroll:1,
  //         asNavFor: ".product-media-modal__content_slider",
  //         responsive: [
  //           {
  //             breakpoint: 767,
  //             settings: {
  //               slidesToShow: 5,
  //             },
  //           },
  //         ],
  //       });
  //   // After unslicking, you can directly select a specific slide.
  //   $('.thumbnail-slider .slick-slide').eq(slideIndex).addClass('selected'); // Highlight the 3rd slide (index 2)


  // }, 100); 
  //       }
        });
        // On click on view more link  END HERE   
    $('.product-media-modal__content_slider').on('afterChange', function(event, slick, currentSlide){
   // console.log("Current slide index: " + currentSlide);
   $('.model-top-content #lg-counter-current').html(currentSlide+1);
   if($(`.product-media-modal__content_slider .slick-slide[data-slick-index=${currentSlide}] img`).attr('alt') !='blank'){
      $('.model-product-title').html($(`.product-media-modal__content_slider .slick-slide[data-slick-index=${currentSlide}] img`).attr('alt'));
      }else{
      $('.model-product-title').html($(`${pmodal}`).attr('data-title'));
      }
       const resizeEvent = new Event('resize');
          // Dispatch the event
        window.dispatchEvent(resizeEvent);
       $('.modal-product-thumbnail .thumb-image').removeClass('selected');
    var targetOffset =$('.modal-product-thumbnail .thumb-image[data-slick-index="'+currentSlide+'"]').offset().left;  // Get the left offset of the target div
    $('.modal-product-thumbnail .thumb-image[data-slick-index="'+currentSlide+'"]').addClass('selected');
    // Animate the horizontal scroll
    $('.modal-product-thumbnail').animate({
      scrollLeft: targetOffset
    }, 800);  // Duration for smooth scroll (800ms)
  
    
  });
  $(document).on('click','.product__media-item',function(e){
   // e.preventDefault();
    var mediaID= $('.product__media img',this).attr('data-mediaid');
    var pmodal= $('.product__modal-opener',this).attr('data-modal');
     model_slider();
    $(`${pmodal} .product-media-modal__content_slider img`).each(function(){
      console.log($(this).attr('data-media-id') + "=="+mediaID);
    if($(this).attr('data-media-id') == mediaID){
       var slideIndex= $(this).parents('.slick-slide').attr('data-slick-index');
      $(".product-media-modal__content_slider").slick("slickGoTo",slideIndex);
     $('.model-top-content #lg-counter-current').html(slideIndex+1);
    $(`product-modal${pmodal}`).attr('open','open');
      if($(this).attr('alt') != ''){
       $('.model-product-title').html($(this).attr('alt'));
      }else{
         $('.model-product-title').html($(`${pmodal}`).attr('data-title'));
      }
    }
    })
  });
$('.model-top-content #lg-share').click(function(e){
e.preventDefault();
$(this).parents('.lg-outer').toggleClass('lg-dropdown-active');
});
$('.model-top-content .lg-dropdown').click(function(e){
event.stopPropagation(); 
});
 $('.model-top-content .lg-fullscreen').click(function(){
   if (!document.fullscreenElement) {  // If not currently in fullscreen mode
        enterFullscreen();
    } else {  // If already in fullscreen mode
        exitFullscreen();
    }
  });
const content = document.querySelector('body');

// Function to enter fullscreen
function enterFullscreen() {
    if (content.requestFullscreen) {
        content.requestFullscreen();
    } else if (content.mozRequestFullScreen) { // Firefox
        content.mozRequestFullScreen();
    } else if (content.webkitRequestFullscreen) { // Chrome, Safari and Opera
        content.webkitRequestFullscreen();
    } else if (content.msRequestFullscreen) { // IE/Edge
        content.msRequestFullscreen();
    }
}

// Function to exit fullscreen
function exitFullscreen() {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { // Chrome, Safari, and Opera
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen();
    }
  const resizeEvent = new Event('resize');
// Dispatch the event
window.dispatchEvent(resizeEvent);
}

var isDragging = false; // Flag to track dragging state
  var startX = 0; // Starting X position of the mouse
  var scrollLeft = 0; // Current scroll position of the container

  // // Initialize the drag handle
  // $('.thumb-image').on('touch,mousedown', function(e) {
  //   // Only drag if the content is wider than the viewport
  //   if ($('.modal-product-thumbnail')[0].scrollWidth > $('.modal-product-thumbnail')[0].clientWidth) {
  //     isDragging = true;
  //     startX = e.pageX;  // Capture the mouse start position
  //     scrollLeft = $('.modal-product-thumbnail').scrollLeft();  // Get the current horizontal scroll position
  //     $('.thumb-image').css('cursor', 'grabbing');  // Change cursor to grabbing
  //   }
  // });

  // // Handle mouse move event
  // $(document).on('mousemove', function(e) {
  //   if (!isDragging) return;  // Do nothing if not dragging

  //   // Calculate the distance moved horizontally
  //   var distance = e.pageX - startX;

  //   // Update the scroll position based on the mouse movement
  //   $('.modal-product-thumbnail').scrollLeft(scrollLeft - distance);

  //   // Optionally animate the scroll (but direct scroll is faster for dragging)
  //   // $('.scroll-container').animate({
  //   //   scrollLeft: scrollLeft - distance
  //   // }, 0);
  // });

  // // Stop dragging on mouse up
  // $(document).on('mouseup', function() {
  //   isDragging = false;  // Reset dragging flag
  //   $('.thumb-image').css('cursor', 'pointer');  // Reset cursor
  // });

  // Prevent text selection while dragging
  // $(document).on('selectstart', function() {
  //   return !isDragging;
  // });
$(document).on('click','product-modal', function(event) {
    // Check if the click is outside the specified divs
    if (!$(event.target).closest('.model-top-content, .model-bottom-content, .product-media-modal__content_slider ').length) {
      // If the click is outside, remove the 'open' attribute from the modal (or any element with the 'open' attribute)
      $('product-modal').removeAttr('open');
      $('body').removeClass('overflow-hidden');
       if (document.fullscreenElement) { 
         exitFullscreen();
       }
    }
  });
